import { useVersionLabelActions } from "./hooks/useVersionLabelActions";

import VersionSelector from "@/components/VersionSelector";
import { EntityType } from "@/queries/folder-entities";

interface SkillCollectionVersionSelectorProps {
  workspaceId: number;
  collectionId: string;
  showVersionList: boolean;
  setShowVersionList: (value: boolean) => void;
  className?: string;
}

export const SkillCollectionVersionSelector = ({
  workspaceId,
  collectionId,
  showVersionList,
  setShowVersionList,
  className,
}: SkillCollectionVersionSelectorProps) => {
  const {
    versions,
    versionsQuery,
    navigateToVersionLink,
    handleAddReleaseLabel,
    handleMoveReleaseLabel,
    handleRemoveReleaseLabel,
    archiveSkillCollectionVersion,
  } = useVersionLabelActions({ workspaceId, collectionId });

  return (
    <VersionSelector
      versions={versions}
      showVersionList={showVersionList}
      setShowVersionList={setShowVersionList}
      navigateToVersionLink={navigateToVersionLink}
      fetchNextPage={versionsQuery.fetchNextPage}
      hasNextPage={versionsQuery.hasNextPage}
      isFetchingNextPage={versionsQuery.isFetchingNextPage}
      onAddReleaseLabel={handleAddReleaseLabel}
      onMoveReleaseLabel={handleMoveReleaseLabel}
      onRemoveReleaseLabel={handleRemoveReleaseLabel}
      refreshVersions={() => versionsQuery.refetch()}
      onArchiveSkillCollectionVersion={{
        mutate: archiveSkillCollectionVersion.mutate,
        isPending: archiveSkillCollectionVersion.isPending,
      }}
      entityType={EntityType.SKILL_COLLECTION}
      className={className}
    />
  );
};
